import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { TriageSidebar } from "../Layouts/TriageSidebar";
import { Preview, print } from "react-html2pdf";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";

export class PreplanAnalysisExecuted extends Component {
  constructor(props) {
    super(props);

   

    //
    const url = "";
    this.state = {
      PreviousDone: "",
      ExamType: "",
      ExamDate: "",
      Result: "",
      myParentTrigger: "",
      patientName: localStorage.getItem("currentVisitName"),
      tablevaluesglobal: {},
      loading: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }

  componentDidMount() {
    $(".yesAnswer").click(function () {
      $(".prePlantable").show();
    });
    $(".noAnswer").click(function () {
      $(".prePlantable").hide();
    });
  }

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      trimobj.ExamDate = data[i][0];
      trimobj.ExamType = data[i][1];
      trimobj.Result = data[i][2];
      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  onTableChange(event) {}

  proceedEvent(event) {
    window.location.href = "/previous/pregnancy/complication";
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("visitId"),
    };

    event.preventDefault();

    // console.log(this.state.tablevaluesglobal[0]['ExamType'])
    for (var i = 0; i < Object.keys(this.state.tablevaluesglobal).length; i++) {
      console.log(this.state.tablevaluesglobal[i]["ExamType"]);
      var dict = {
        ExamType: this.state.tablevaluesglobal[i]["ExamType"],
        ExamDate: this.state.tablevaluesglobal[i]["ExamDate"],
        Result: this.state.tablevaluesglobal[i]["Result"],

        PreviousDone: this.state.PreviousDone,
      };
      console.log(dict);

     this.setState({
      loading: true
     })
      axios
        .post(this.api_url+""+localStorage.getItem('currentModule')+"/preplan/main", dict, {
          headers: headers,
        })
        .then((response) => {
          console.log(response);
          this.setState({
            loading: false
           })
          if (response.data == "No results found") {
            $(".noResultsFound").show();
            $(".alert-success").hide();
          } else {
            $(".noResultsFound").hide();
            $(".alert-success").show();

            $(response).each(function (index) {
              var individualResult =
                '<div className="card"> <div className="card-body">' +
                index.name +
                "</div> </div>";
              // $('.alert-success').append(individualResult);
            });
            $(".alert-success").show();

            this.setState({ response: response });
            setTimeout(function () {
              // alert('sdsd')
              window.location.href = "/previous/pregnancy/complication";
              // $('.HistoryModal').show()
            }, 1500);

            axios
              .get(this.api_url+"/triage/preplan/main", {
                headers: headers,
              })
              .then((response) => {
                console.log(response);
                let table = response.data;
                console.log(table);
                let object = {};
                for (let i = 0; i < table.length; i++) {
                  delete table[i]._id;
                  delete table[i].timeOfRegistration;
                  table[i].clickEvent = () => this.handleRowClick(table[i]);
                }
                // table = JSON.stringify(table);
                this.TableData = table;
                console.log(this.TableData);
                this.setState({
                  DataLoaded: true,
                });
              })
              .catch((error) => {
                console.log(error);
              });
            // console.log(response)alert-success
            //
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  handleTableChange(event) {
    console.log(event);
    this.setState({ myParentTrigger: this.state.myParentTrigger + "a" });
  }

  getTableValues(event) {
    console.log("entns");
    console.log(event);
    let tablevalues = this.formatTableOutput(event);
    console.log(tablevalues);
  }

  render() {
    const data = [["", "", ""]];
    const columns = ["Exam Date", "Exam Type", "Result"];
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    // const floatRight = {float:'right;'}
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };
    const { PreviousDone, ExamType, ExamDate, patientName, loading } = this.state;

    let { DataLoaded } = this.state;
    const tabledata = {
      columns: [
        {
          label: "Exam Date",
          field: "ExamDate",
          sort: "asc",
          width: 50,
        },
        {
          label: "Exam Type",
          field: "ExamType",
          sort: "asc",
          width: 50,
        },
        {
          label: "Result",
          field: "Result",
          sort: "asc",
          width: 50,
        },
      ],
      rows: this.TableData,
    };

    return (
      <div>
        <Headers />
        <TriageSidebar></TriageSidebar>

        <main className="content-container ">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Preplan Analysis executed
                  </p>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Is Preplan Analysis executed?
                    </h6>
                    <select
                      className="form-control PreviousDone"
                      onChange={this.handleChange}
                      value={PreviousDone}
                      name="PreviousDone"
                      required
                    >
                      <optgroup label="pre plan Analysis Executed">
                        <option selected disabled></option>
                        <option className="yesAnswer" value="yes">
                          Yes
                        </option>
                        <option className="noAnswer" value="no">
                          No
                        </option>
                      </optgroup>
                    </select>
                  </div>
                </div>
              </div>

              <div className="prePlantable" style={displayHidden}>
                <MDBCard>
                  <MDBCardHeader
                    tag="h3"
                    className="text-center font-weight-bold text-capitalise py-4"
                  >
                    Pre-plan Analysis
                  </MDBCardHeader>
                  <MDBCardBody>
                    <MDBTableEditable
                      onChange={(value) => this.handleTableChange(value)}
                      getValue={(value) => this.getTableValues(value)}
                      myParentTrigger={this.state.myParentTrigger}
                      id="editablecard"
                      data={data}
                      columns={columns}
                      striped
                      bordered
                    />
                  </MDBCardBody>
                </MDBCard>
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>PrePlan Analysis Saved Successfully.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                  {loading ? 'Loading' : 'Submit'}  
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div className="modal  HistoryModal" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {" "}
                    {patientName}`s OB Sound Modal
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  {/* <div className="py-1">
                            <h6 className="text-capitalize" style={ fontFamilyNunito }>Name</h6><input className="form-control"   type="text" required/>
                        </div> */}
                  <br />
                  <a
                    className="btn btn-danger proceed"
                    onClick={this.proceedEvent}
                    style={width100}
                  >
                    Proceed to Next
                  </a>
                  <Preview id={"jsx-template"}>
                    <b>NAME: </b>
                    {patientName}

                    <MDBDataTable striped bordered data={tabledata} />
                  </Preview>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default PreplanAnalysisExecuted;
